import { tz } from '@date-fns/tz';
import { parseISO } from 'date-fns/parseISO';

/**
 * Parses a Platform timestamp, which is UTC but carries no offset. Parsed
 * without a UTC context it would be read as the reader's local wall time,
 * skewing every comparison by their offset and inverting it west of UTC.
 */
export const parseUtcTimestamp = (timestamp: string) =>
  parseISO(timestamp, { in: tz('UTC') });

/**
 * Parses the calendar-day portion of an ISO date string into a system-local
 * Date, ignoring the time and offset suffix. Used for hydrating UI controls
 * that need to render the originally-picked day regardless of what offset it
 * was stored with — `parseISO` (and `new Date`) of a full ISO string absorbs
 * the offset and shifts the day for east-of-UTC users.
 */
export const parseLocalCalendarDate = (
  iso: string | null | undefined,
): Date | null => {
  if (!iso) return null;

  const date = parseISO(iso.slice(0, 10));

  return Number.isNaN(date.valueOf()) ? null : date;
};
